import styled from 'styled-components';
import BREAKPOINT from 'assets/styles/breakpoints';
import { COLOR } from 'assets/styles/colors';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  img {
    margin: 26px 0 39px 24px;
  }
    /* Ipad-Notebook */
    @media screen and (min-width: ${BREAKPOINT.MD}) {
      img {
        margin: 44px 0 39px 90px;
      }
  }
`;

export const BoxMaintenance = styled.section`
  width: 100%;
  background: ${COLOR.WHITE_5};
  height: 329px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  div {
    max-width: 664px;
    padding: 0 24px;
    h1 {
      margin: 32px 0 0 0;
      font-weight: 600;
      font-size: 24px;
      line-height: 125%;
      color: ${COLOR.GREEN_1};
      text-align: left;
    }
    h2 {
      margin: 32px 0 24px 0;
      font-weight: 500;
      font-size: 18px;
      line-height: 115%;
      color: ${COLOR.GREY_1};
      text-align: left;
    }
  }

  /* Ipad-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    height: 367px;
    div {
      padding: 0;
      h1 {
        margin: 50px 0 0 0;
        font-size: 44px;
      }
      h2 {
        margin: 44px 0 32px 0;
        font-size: 26px;
      }
    }
  }
`;

export const ContainerButton = styled.div`
  width: 100%;
  padding: 0 24px;
  .MuiButton-root {
    width: 100% !important;
    margin: 0 !important;
  }
      /* Ipad-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    padding: 0;
    margin: 0 0 0 90px;
    width: 442px;
  }
`;
